import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { SEOLinksState, IRegion } from 'modules/SEOLinking/SEOLinking.interfaces';
import { useLocation } from 'react-router-dom';
import { getSEOLinks } from 'modules/SEOLinking/SEOLinking.actions';
import SEOLink, { SEOLinkWrapper } from './SEOLinkingControl.style';

interface IMenuItems {
  label: string;
  url: string;
}

export const SEOLinksControl = () => {
  const location = useLocation();

  const { regions } = useSelector(({ seoLinksReducer }: { seoLinksReducer: SEOLinksState }) => seoLinksReducer);
  const [menuItems, setMenuItems] = useState<IMenuItems[]>([]);
  const [selectedCity, setSelectedCity] = useState<string | null>();
  const [selectedRegion, setSelectedRegion] = useState<string | null>();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSEOLinks.request());
  }, []);

  useEffect(() => {
    const pathComponents = location.pathname.split('/');
    if (pathComponents[1] == 'regions' && pathComponents[2] != undefined) {
      setSelectedRegion(pathComponents[2]);
    } else if (pathComponents[1] == 'villes' && pathComponents[2] != undefined) {
      setSelectedCity(pathComponents[2]);
    } else {
      setSelectedCity(null);
      setSelectedRegion(null);
    }
  }, [location]);

  const getMenu = () => {
    let menuItems: IMenuItems[] = [];
    if (regions) {
      if (selectedCity) {
        for (const r of regions) {
          for (const c of r.cities) {
            if (c.city_name == selectedCity) {
              menuItems = c.tags.map((tag) => ({
                url: `/villes/${c.city_name}/${tag}`,
                label: t('seo_tag', { city_name: c.city_name, tag: tag }),
              }));
              break;
            }
          }
          if (menuItems.length > 0) break;
        }
      } else if (selectedRegion) {
        const region: IRegion | undefined = regions.filter((r) => r.region_name == selectedRegion)[0];
        menuItems = region?.cities.map((c) => ({
          url: `/villes/${c.city_name}`,
          label: t('seo_city', { city_name: c.city_name }),
        }));
      } else {
        menuItems = regions.map((r) => ({
          url: `/regions/${r.region_name}`,
          label: t('seo_region', { region_name: r.region_name }),
        }));
      }
    }
    setMenuItems(menuItems);
  };

  useEffect(() => {
    getMenu();
  }, [regions, selectedCity, selectedRegion]);

  return (
    <SEOLinkWrapper>
      {menuItems.map((item, index) => (
        <SEOLink to={item.url} key={index}>
          {item.label}
        </SEOLink>
      ))}
    </SEOLinkWrapper>
  );
};
